import calculated from './calculated';
import * as colors from './colors';
import * as images from './images';
import * as letters from './letters';
import * as simple from './simple';

export default () => ({
  ...calculated(),
  ...colors,
  ...images,
  ...letters,
  ...simple
});
